var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2672)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11_2672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 24C1.009 24 0 22.991 0 21.75V5.25C0 4.009 1.009 3 2.25 3H6V0.75C6 0.336 6.336 0 6.75 0C7.164 0 7.5 0.336 7.5 0.75V3H16.5V0.75C16.5 0.336 16.836 0 17.25 0C17.664 0 18 0.336 18 0.75V3H21.75C22.991 3 24 4.009 24 5.25V21.75C24 22.991 22.991 24 21.75 24H2.25ZM2.25 4.5C1.836 4.5 1.5 4.836 1.5 5.25V21.75C1.5 22.164 1.836 22.5 2.25 22.5H21.75C22.164 22.5 22.5 22.164 22.5 21.75V5.25C22.5 4.836 22.164 4.5 21.75 4.5H18V6C18 6.414 17.664 6.75 17.25 6.75C16.836 6.75 16.5 6.414 16.5 6V4.5H7.5V6C7.5 6.414 7.164 6.75 6.75 6.75C6.336 6.75 6 6.414 6 6V4.5H2.25Z",
    fill: "#AE4182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 19.5C4.836 19.5 4.5 19.164 4.5 18.75V14.25C4.5 13.836 4.836 13.5 5.25 13.5H9V9.75C9 9.336 9.336 9 9.75 9H18.75C19.164 9 19.5 9.336 19.5 9.75V18.75C19.5 19.164 19.164 19.5 18.75 19.5H5.25ZM18 18V15H15V18H18ZM13.5 18V15H10.5V18H13.5ZM9 18V15H6V18H9ZM18 13.5V10.5H15V13.5H18ZM13.5 13.5V10.5H10.5V13.5H13.5Z",
    fill: "#AE4182"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.e7266085c27aecd8a04aaa6167ddd3f5.svg";
export { ForwardRef as ReactComponent };